import { AbstractBlock } from "./AbstractBlock";
/**
 * An abstract class for assembly blocks that return 
 */
export abstract class ReturnBlock extends AbstractBlock{
    abstract evalBlock(varEnv: Map<string, any>): any;
}